<div>
  @if (entity().isClosed) {
    <span class="ui-tag badge rounded-pill bg-secondary mx-1">{{
      '::isClosed' | abpLocalization
    }}</span>
  }
  @if (entity().isDraft) {
    <span class="ui-tag badge rounded-pill bg-info mx-1">{{ '::Draft' | abpLocalization }}</span>
  }
  @if (entity().isBlocked) {
    <span class="ui-tag badge rounded-pill bg-danger mx-1" title="{{ entity().blockedReason }}">
      {{ 'Doc::CustomerQuote:IsBlocked' | abpLocalization }}
    </span>
  }
  @if (entity().litigation) {
    <span
      class="ui-tag badge rounded-pill bg-warning mx-1"
      title="{{ entity().litigationReason }}"
      >{{ 'Doc::CustomerQuote:Litigation' | abpLocalization }}</span
    >
  }
  @if (entity().isCancelled) {
    <span class="ui-tag badge rounded-pill bg-warning mx-1">{{
      '::Cancelled' | abpLocalization
    }}</span>
  }
  @if (entity().peppolStatus?.length > 0) {
    <dw-core-tag-enum
      title="{{ 'Doc::PeppolStatus' | abpLocalization }}"
      [id]="entity().peppolStatus"
      [enumerationTypes]="enumerationTypeStore.peppolStatuses()"
    ></dw-core-tag-enum>
  }
  @if (entity().peppolSendStatus?.length > 0) {
    <dw-core-tag-enum
      title="{{ 'Doc::PeppolSendStatus' | abpLocalization }}"
      [id]="entity().peppolSendStatus"
      [enumerationTypes]="enumerationTypeStore.peppolSendStatus()"
    ></dw-core-tag-enum>
  }
</div>
